import {
  QUALIFIER_CONFIG_SUCCESS,
  CATALOG_FILTER_DATA,
  FETCH_START,
  FETCH_END,
  EDI_MAPPINGS_SUCCESS,
  PRICE_TYPE_CONFIG_SUCCESS,
  PRICE_LIST_MASTER_SUCCESS,
  PRICE_LIST_MASTER_BY_ID,
  PRICE_QUALIFIER_NAME_SUCCESS,
  PRICE_NEW_QUALIFIER_NAME_SUCCESS,
  GLOBAL_CONTRACT_CONFIG_BY_APP_TYPE,
  GLOBAL_CONTRACT_CONFIG_BY_CONTRACT_TYPE,
  CUSTOM_TABLE_FIELDS_SUCCESS,
  PRICE_TYPE_NAME_SUCCESS,
  PRICE_LIST_DATA_SUCCESS,
  PRICE_LIST_DATA_BY_ID,
  PRICE_MAINTENANCE_FIELDS,
  PRICE_MAINTENANCE_FIELDS_NEW,
  DISTINCT_PRICE_LIST_DATA,
  PRICE_FORMULA_BY_ID,
  PRICE_FORMULA_SUCCESS,
  LIST_DATA_FORMAT_SUCCESS,
  OFF_INVOICE_CONFIG_SUCCESS,
  CONF_EDI_MAPPINGS_SUCCESS,
  CONF_ID_EDI_MAPPINGS_SUCCESS,
  PRICE_CAL_FOR_LIST_SUCCESS,
  PRICE_CAL_FOR_LIST_BY_ID,
  PRICE_CAL_FOR_LIST_BY_NAME,
  PRICE_CAL_FOR_SIMULATION_SUCCESS,
  SIMULATION_DROPDOWN_SUCCESS,
  PRICE_ELASTICITY,
  PRICE_SIMULATION_DATA_SUCCESS,
  PRICE_CATALOG_DATA_SUCCESS,
  PRICE_SIM_RESULTS_SUCCESS,
  LIST_DATA_UPLOAD_FAILURE,
  CUSTOMER_MARGIN_SUCCESS,
  PRICE_POLICY_EXCEP,
  DISTINCT_PROFIT_LIST_DATA,
  COMPREHENCIVE_QUOTE_DATA,
  COMPREHENCIVE_QUOTE_DATA_BY_ID,
  PRICE_SIMULATION_LIST_DATA,
  PRICE_SIMULATION_DATA_BY_ID,
  PRICE_CATALOG_LIST_DATA,
  PRICE_MAINTENANCE_FIELDS_BY_PRICE_TYPE,
  PRICE_LIST_DATA_MESSAGELOG,
  PRICE_UNIQUE_SUCCESS,
  PRICE_FILTER_DATA,
  PRICE_CATALOG_SUCCESS,
  PRICE_CHANGE_HISTORY_DATA_SUCCESS,
  PRICE_ADJUST_SUCCESS,
  PRICE_REQUEST_CONFIG_BY_ID,
  PRICE_REQUEST_CONFIG_SUCCESS,
  PRICE_SIMULATION_CONFIG_BY_ID,
  PRICE_SIMULATION_CONFIG_SUCCESS,
  PRICE_CATALOG_CONFIG_SUCCESS,
  PRICE_CATALOG_CONFIG_BY_ID,
  PRICE_REASON_CODE_CONFIG_SUCCESS,
  PRICE_REQUESTS_LIST_SUCCESS,
  PRICE_REQUESTS_SUCCESS,
  PRICE_REQUESTS_LIST_ID_SUCCESS,
  PRICE_REQUESTS_BY_ID_SUCCESS,
  RESET_PRICE_MAINTENANCE_FIELDS,
  PRICE_CONTRACTS_LIST,
  PRICE_CONTRACT_ID,
  PRICE_CONTRACTS,
  PRICE_CONTRACT_APPROVAL,
  PRICE_PROFILE_SELECTION_SUCCESS,
  LAYOUT_DATA_SUCCESS,
  PRICE_WORKFLOW_NAME_SUCCESS,
  PRICE_PROFILE_SELECTION_BY_ID,
  PRICE_PROFILE_SELECTION_ATTRIBUTES,
  PRICE_WORKFLOW_STATUS_SUCCESS,
  PRICE_WORKFLOW_NEXT_STATUS_SUCCESS,
  CLEAR_WORKFLOW_STATUS_DATA,
  WORKFLOW_STATUS,
  LIST_DATA_FORMAT_BY_ID,
  PRICE_CONTRACT_FIELDS,
  PRICE_LAYOUT_SUCCESS,
  PRICE_LAYOUT_BY_ID_SUCCESS,
  PRICE_PROFILE_CONFIGURATION_SUCCESS,
  PRICE_PROFILE_CONFIGURATION_BY_ID,
  PRICE_LAYOUT_BY_QUOTE_SUCCESS,
  PRICE_LAYOUT_BY_DOCUMENT_SUCCESS,
  PRICE_POINTS_SUCCESS,
  PRICE_HISTORY_SUCCESS,
  PRICE_HISTORY_BY_ID_SUCCESS,
  PRICE_POINTS_BY_ID,
  PRICE_POINTS_BY_NAME,
  DELETE_PRICE_POINT_SUCCESS,
  DELETE_PRICE_POINT_ERROR,
  PRICE_POINT_EXECUTE_SUCCESS,
  PRICE_POINT_EXECUTE_ERROR,
  CLEAR_PRICE_POINT_EXECUTE_RESULT, PRICE_LIST_CONFIG,
  SET_SELECTED_PRICE_LIST_BY_RULE,
  SET_UNSAVED_PRICE_CHANGES,
  CLEAR_UNSAVED_PRICE_CHANGES,
} from './ActionTypes';
import secureLocalStorage from 'react-secure-storage';
import axios from '../../../axios.conf';
import { history } from '../../../components/Helpers';
import { toast } from 'react-toastify';
import { toast as newToast } from '../../../components/ToastManager';
import { handleExecutionLog } from '../../../components/ExecutionLogHandler';
import { ServerError } from '../../../library/constants';
import { es } from 'date-fns/locale';
export const fetchStart = (item) => {
  return {
    type: FETCH_START,
    item,
  };
};

export const fetchEnd = (item) => {
  return {
    type: FETCH_END,
    item,
  };
};

export const getQualifierConfigSuccess = (data) => {
  return {
    type: QUALIFIER_CONFIG_SUCCESS,
    data,
  };
};

export const getQualifierConfig = (pagination, limit) => {
  return (dispatch) => {
    getQualifierConfigAPI(pagination, limit)
      .then((response) => {
        dispatch(getQualifierConfigSuccess(response.data.response));
      })
      .catch((error) => { });
  };
};

const getQualifierConfigAPI = (pagination, limit) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get(
    'pricing/price-attributes?page=' + pagination + '&limit=' + limit,
    { headers: headers },
  );
  return result;
};

//EDI Mapping fetch data

export const getEDIMappings = (name) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getEDIMappingsAPI(name)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getEDIMappingsSuccess(response.data.response));
      })
      .catch((error) => { dispatch(fetchEnd()); });
  };
};

const getEDIMappingsAPI = (name) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('edi-segments?' + 'edi_map=' + name, { headers: headers });

  return result;
};
export const getEDIMappingsSuccess = (data) => {
  return {
    type: EDI_MAPPINGS_SUCCESS,
    data,
  };
};

//price type config

export const getPriceTypeConfig = (pagination, limit, name) => {
  return (dispatch) => {
    getPriceTypeConfigAPI(pagination, limit, name)
      .then((response) => {
        dispatch(getPriceTypeConfigSuccess(response.data.response));
      })
      .catch((error) => { });
  };
};

const getPriceTypeConfigAPI = (pagination, limit, name) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (name)
    result = axios.get(
      'pricing/price-types' +
      pagination +
      '&limit=' +
      limit +
      '&price_type_name=' +
      name,
      { headers: headers },
    );
  else result = axios.get('pricing/price-types', { headers: headers });
  return result;
};
export const getPriceTypeConfigSuccess = (data) => {
  return {
    type: PRICE_TYPE_CONFIG_SUCCESS,
    data,
  };
};
export const deletePricingCalcStep = (id, name) => {
  return (dispatch) => {
    deletePricingCalcStepAPI(id)
      .then((response) => {
        dispatch(getPriceCalForListByName(name));
      })
      .catch((error) => { });
  };
};

const deletePricingCalcStepAPI = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };

  var result = axios.delete('pricing-calc-formula-ind/' + id, {
    headers: headers,
  });

  return result;
};

//price list master

export const getPriceListMaster = (pagination, limit, id, usage) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getPriceListMasterAPI(pagination, limit, id, usage)
      .then((response) => {
        dispatch(fetchEnd());
        // Normalize API response so priceListMasterData always has { records: [...] } with price_list_id
        const raw = response.data;
        const inner = raw?.response ?? raw?.data ?? raw;
        const records = Array.isArray(inner)
          ? inner
          : (inner?.records ?? inner?.Records ?? []);
        const normalizedRecords = Array.isArray(records) ? records : [];
        dispatch(getPriceListMasterSuccess({ records: normalizedRecords }));
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const getPriceListMasterAPI = (pagination, limit, params, usage) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (params) {
    result = axios.get(
      'config/price-list-masters',
      { params, headers: headers },
    );
  } else if (usage) {
    result = axios.get(
      'config/price-list-masters?page=' +
      pagination +
      '&limit=' +
      limit +
      '&usage=' +
      usage +
      '&application_type=' +
      sessionStorage.getItem('application'),
      { headers: headers },
    );
  } else
    result = axios.get(
      'config/price-list-masters?page=' + pagination + '&limit=' + limit,
      { headers: headers },
    );
  return result;
};
export const getPriceListMasterSuccess = (data) => {
  return {
    type: PRICE_LIST_MASTER_SUCCESS,
    data,
  };
};

export const createPriceListMaster = (data, id, type, appType) => {
  return (dispatch) => {
    dispatch(fetchStart());
    createPriceListMasterAPI(data, id, type)
      .then((response) => {
        dispatch(fetchEnd());
        if (type === 'delete') dispatch(getPriceListMaster(1, 100, appType && { application_type: appType }));
        else history.push({ pathname: '/pricing-list-master', state: { application: appType ? appType : null } });
        newToast.showSuccess(response.data.response);
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const createPriceListMasterAPI = (data, id, type) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (type === 'edit') {
    result = axios.put('config/price-list-master/' + id, data, {
      headers: headers,
    });
  } else if (type === 'delete') {
    result = axios.delete('config/price-list-master/' + id, {
      headers: headers,
    });
  } else {
    result = axios.post('config/price-list-masters', data, {
      headers: headers,
    });
  }
  return result;
};

export const getPriceListMasterById = (id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getPriceListMasterByIdAPI(id)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getPriceListMasterByIdSuccess(response.data.response));
        // history.push('/pricing-list-master/edit-list-master/' + id);
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const getPriceListMasterByIdAPI = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('config/price-list-master/' + id, { headers: headers });
  return result;
};

export const getPriceListMasterByIdSuccess = (data) => {
  return {
    type: PRICE_LIST_MASTER_BY_ID,
    data,
  };
};

export const getPriceFieldValues = (qualifierKey) => {
  return (dispatch) => {
    getPriceFieldValuesAPI(qualifierKey)
      .then((response) => {
        if (qualifierKey == 'attribute_key')
          dispatch(getPriceFieldValuesSuccess(response.data.response));
        else dispatch(getPriceTypeFieldValuesSuccess(response.data.response));
      })
      .catch((error) => { });
  };
};

const getPriceFieldValuesAPI = (qualifierKey) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (sessionStorage.getItem('application') == 'Profit Optimization')
    result = axios.get('profit-field-values?name=' + qualifierKey, {
      headers: headers,
    });
  else
    result = axios.get('pricing/price-field-values?name=' + qualifierKey, {
      headers: headers,
    });
  return result;
};
export const getPriceFieldValuesSuccess = (data) => {
  return {
    type: PRICE_QUALIFIER_NAME_SUCCESS,
    data,
  };
};
export const getPriceTypeFieldValuesSuccess = (data) => {
  return {
    type: PRICE_TYPE_NAME_SUCCESS,
    data,
  };
};
//price maintenance
export const getPriceListData = (pagination, limit, params, page, filters) => {
  return (dispatch) => {
    dispatch(fetchStart());

    return getPriceListDataAPI(pagination, limit, params, page, filters)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getPriceListDataSuccess(response.data.response));
        // console.log('resulthere', response.data.response);
        return response.data.response; // Return the data so we can use .then() after dispatch
      })
      .catch((error) => {
        console.error('Error fetching price list data:', error);
      });
  };
};

const getPriceListDataAPI = (pagination, limit, params, page, filters) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (page === 'maintainPrices') {
    result = axios.post('active-price-records', filters, {
      params: params,
      headers: headers,
    });
  } else if (page === 'editDriverMaintenance') {
    result = axios.get(
      'profit-analysis-level-data?limit=0',
      { params: params, headers: headers },
    );
  } else {
    if (params) {
      if (page == 'approval')
        result = axios.get(
          'price-list-data?price_list_id=' +
          params.id +
          '&price_type_name=' +
          params.priceName +
          '&calculation_type=' +
          params.calcType +
          '&approval_status=new&page=' +
          pagination +
          '&limit=' +
          limit,
          { headers: headers },
        );
      else
        result = axios.get(
          'price-list-data?price_list_id=' +
          params +
          '&page=' +
          pagination +
          '&limit=' +
          limit,
          { headers: headers },
        );
    } else
      result = axios.get(
        'price-list-data-distinct?page=' + pagination + '&limit=' + limit,
        { headers: headers },
      );
  }
  return result;
};
export const getPriceListDataSuccess = (data) => {
  return {
    type: PRICE_LIST_DATA_SUCCESS,
    data,
  };
};

export const createPriceListData = (data, priceListId, id, type) => {
  return (dispatch) => {
    createPriceListDataAPI(data, priceListId, id, type)
      .then((response) => {
        if (type == 'delete') {
          if (sessionStorage.getItem('application') == 'Price Management') {
            dispatch(getAllDistinctPriceListData(1, 0));
            history.push('/pricing-maintenance');
          }
          if (sessionStorage.getItem('application') == 'Profit Optimization') {
            dispatch(getAllDistinctPriceListData(1, 15));
            history.push('/driver-maintenance');
          }
        } else dispatch(getPriceListData(1, 0, priceListId));
        toast.success(response.data.response?.message);
      })
      .catch((error) => { });
  };
};

const createPriceListDataAPI = (data, priceListId, id, type) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (type === 'edit') {
    if (sessionStorage.getItem('application') == 'Profit Optimization')
      result = axios.put('profit-analysis-level-data/' + id, data, {
        headers: headers,
      });
    else
      result = axios.put('price-list-data/' + id, data, { headers: headers });
  } else if (type === 'delete') {
    if (id) {
      if (sessionStorage.getItem('application') == 'Profit Optimization')
        result = axios.delete('profit-analysis-level-data/' + id, {
          headers: headers,
        });
      else result = axios.delete('price-list-data/' + id, { headers: headers });
    } else {
      if (sessionStorage.getItem('application') == 'Profit Optimization') {
        result = axios.delete(
          'profit-analysis-level-data?price_list_id=' + priceListId,
          { headers: headers },
        );
      } else {
        result = axios.put('price-type-price-list-data', priceListId, {
          headers: headers,
        });
        //result = axios.delete('price-list-data', priceListId, { headers: headers });
      }
    }
  } else {
    if (sessionStorage.getItem('application') == 'Profit Optimization')
      result = axios.post('profit-analysis-level-data', data, {
        headers: headers,
      });
    else result = axios.post('price-list-data', data, { headers: headers });
  }
  return result;
};

// redirectTo: optional post-save route for maintainPrices callers (e.g. Exception Management); defaults to /pricing-requests.
export const createPriceListDataAll = (data, page, type, id, redirectTo) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await createPriceListDataAllAPI(data, page, type, id);
      dispatch(fetchEnd());
      const logNumber = response?.data?.log_number;
      if (type === 'delete') {
        newToast.showSuccess(response.data.response);
        dispatch(pricingRequests());
        return { success: true, response };
      }
      if (response.data.success === true && page === 'maintainPrices') {
        history.push(redirectTo || '/pricing-requests');
      }
      if (logNumber) {
        const { hasError } = await handleExecutionLog(dispatch, logNumber);
        if (response.data.messageLog) {
          dispatch(getPriceListDataError(response.data));
        }
        return { success: !hasError, response };
      }

      // else {
      //   newToast.showSuccess(response.data.message);
      //   if (response.data.messageLog) {
      //     dispatch(getPriceListDataError(response.data));
      //   } else {
      //     history.push('/pricing-requests');
      //   }
      //   return { success: true, response };
      // }
    } catch (error) {
      dispatch(fetchEnd());
      const logNumber = error?.response?.data?.log_number;
      if (logNumber) {
        const { hasError } = await handleExecutionLog(dispatch, logNumber);
        return { success: !hasError, response: error.response };
      }
      throw error;
    }
  };
};

const createPriceListDataAllAPI = (data, page, type, id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  if (sessionStorage.getItem('application') == 'Profit Optimization')
    var result = axios.put('profit-analysis-level-data', data, {
      headers: headers,
    });
  else if (type === 'delete') {
    result = axios.delete(
      'pricing/price-request/' + id + '?application_type=Price Management',
      { headers: headers },
    );
  } else
    var result = axios.post('pricing/price-request', data, {
      headers: headers,
    });
  return result;
};
export const getPriceListDataError = (data) => {
  return {
    type: PRICE_LIST_DATA_MESSAGELOG,
    data,
  };
};

export const getPriceListDataById = (id) => {
  return (dispatch) => {
    getPriceListDataByIdAPI(id)
      .then((response) => {
        dispatch(getPriceListDataByIdSuccess(response.data.response));
        history.push('/pricing-maintenance/edit-list-data/' + id);
      })
      .catch((error) => { });
  };
};

const getPriceListDataByIdAPI = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('price-list-data/' + id, { headers: headers });
  return result;
};

export const getPriceListDataByIdSuccess = (data) => {
  return {
    type: PRICE_LIST_DATA_BY_ID,
    data,
  };
};

// price maintenance fields

export const getPriceMaintenanceFields = (priceListId) => {
  return (dispatch) => {
    getPriceMaintenanceFieldsAPI(priceListId)
      .then((response) => {
        dispatch(getPriceMaintenanceFieldsSuccess(response.data.response));
      })
      .catch((error) => { });
  };
};

export const resetPriceMaintenanceFields = () => {
  return {
    type: 'RESET_PRICE_MAINTENANCE_FIELDS',
  };
};

const getPriceMaintenanceFieldsAPI = (priceListId) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (priceListId)
    result = axios.get('price-list-fields?price_list_id=' + priceListId, {
      headers: headers,
    });
  else result = axios.get('price-list-fields', { headers: headers });
  return result;
};

export const getPriceMaintenanceFieldsSuccess = (data) => {
  return {
    type: PRICE_MAINTENANCE_FIELDS,
    data,
  };
};

//price type based

export const getPriceMaintenanceFieldsByPriceType = (data) => {
  return (dispatch) => {
    getPriceMaintenanceFieldsByPriceTypeAPI(data)
      .then((response) => {
        dispatch(
          getPriceMaintenanceFieldsByPriceTypeSuccess(response.data.response),
        );
      })
      .catch((error) => { });
  };
};

const getPriceMaintenanceFieldsByPriceTypeAPI = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.post('pricing/price-list/fields', data, { headers: headers });
  return result;
};

export const getPriceMaintenanceFieldsByPriceTypeSuccess = (data) => {
  return {
    type: PRICE_MAINTENANCE_FIELDS_BY_PRICE_TYPE,
    data,
  };
};

export const getAllDistinctPriceListData = (pagination, limit, type, data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getAllDistinctPriceListDataAPI(pagination, limit, type, data)
      .then((response) => {
        dispatch(fetchEnd());
        if (sessionStorage.getItem('application') == 'Profit Optimization')
          dispatch(getAllDistinctProfitListDataSuccess(response.data.response));
        else
          dispatch(getAllDistinctPriceListDataSuccess(response.data.response));
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const getAllDistinctPriceListDataAPI = (pagination, limit, type, data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (sessionStorage.getItem('application') == 'Profit Optimization')
    result = axios.get(
      'profit-analysis-level-data-distinct?page=' +
      pagination +
      '&limit=' +
      limit,
      { headers: headers },
    );
  else {
    if (type == 'approval')
      result = axios.get(
        'price-list-data-distinct?page=' +
        pagination +
        '&limit=' +
        limit +
        '&approval_status=new',
        { headers: headers },
      );
    else {
      // result = axios.get('price-list-data-distinct?page=' + pagination + '&limit=' + limit, { headers: headers });
      result = axios.post('pricing/price-list/summary ', data, {
        headers: headers,
      });
    }
  }
  return result;
};
export const getAllDistinctPriceListDataSuccess = (data) => {
  return {
    type: DISTINCT_PRICE_LIST_DATA,
    data,
  };
};
export const getAllDistinctProfitListDataSuccess = (data) => {
  return {
    type: DISTINCT_PROFIT_LIST_DATA,
    data,
  };
};

// pricing Formula
export const getPriceFormula = (pagination, limit) => {
  return (dispatch) => {
    getPriceFormulaAPI(pagination, limit)
      .then((response) => {
        dispatch(getPriceFormulaSuccess(response.data.response));
      })
      .catch((error) => { });
  };
};

const getPriceFormulaAPI = (pagination, limit) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('pricing-formula?page=' + pagination + '&limit=' + limit, {
    headers: headers,
  });
  return result;
};
export const getPriceFormulaSuccess = (data) => {
  return {
    type: PRICE_FORMULA_SUCCESS,
    data,
  };
};

export const createPriceFormula = (data, id, type) => {
  return (dispatch) => {
    createPriceFormulaAPI(data, id, type)
      .then((response) => {
        if (type === 'delete') dispatch(getPriceFormula(1, 100));
        else history.push('/pricing-formula');
        toast.success(response.data.response);
      })
      .catch((error) => { });
  };
};

const createPriceFormulaAPI = (data, id, type) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (type === 'edit') {
    result = axios.put('pricing-formula/' + id, data, { headers: headers });
  } else if (type === 'delete') {
    result = axios.delete('pricing-formula/' + id, { headers: headers });
  } else {
    result = axios.post('pricing-formula', data, { headers: headers });
  }
  return result;
};

export const getPriceFormulaById = (id) => {
  return (dispatch) => {
    getPriceFormulaByIdAPI(id)
      .then((response) => {
        dispatch(getPriceFormulaByIdSuccess(response.data.response));
        //history.push('/pricing-type-config/edit-type-config/' + id);
      })
      .catch((error) => { });
  };
};

const getPriceFormulaByIdAPI = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('pricing-formula/' + id, { headers: headers });
  return result;
};

export const getPriceFormulaByIdSuccess = (data) => {
  return {
    type: PRICE_FORMULA_BY_ID,
    data,
  };
};
//price calculation

export const runPriceCalculation = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    runPriceCalculationAPI(data)
      .then((response) => {
        dispatch(fetchEnd());
        toast.success(response.data.response);
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const runPriceCalculationAPI = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.post('pricing-formula-calc-sim', data, { headers: headers });

  return result;
};

// price maintainence upload

export const createPriceMaintenanceUpload = (data, id, type, redirectTo) => {
  return (dispatch) => {
    createPriceMaintenanceUploadAPI(data, id, type)
      .then((response) => {
        history.push(redirectTo || '/pricing-maintenance/pricing-maintenance-excel-upload');
        dispatch(fetchPriceListDataUpload());
        toast.success(response.data.response);
      })
      .catch((error) => { });
  };
};

const createPriceMaintenanceUploadAPI = (data, id, type) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (type === 'edit') {
    result = axios.put(
      'upload-format/' + id + '?app-functionality=PriceListDataFormat',
      data,
      { headers: headers },
    );
  } else if (type === 'delete') {
    result = axios.delete('upload-format/' + id, { headers: headers });
  } else {
    result = axios.post(
      'upload-format?app-functionality=PriceListDataFormat',
      data,
      { headers: headers },
    );
  }
  return result;
};

export const fetchPriceListDataUpload = (id) => {
  return (dispatch) => {
    fetchPriceListDataUploadAPI(id)
      .then((response) => {
        dispatch(fetchPriceListDataUploadSuccess(response.data.response, id));
      })
      .catch((error) => { });
  };
};

const fetchPriceListDataUploadAPI = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (id) {
    result = axios.get(
      'upload-format/' + id + '?app-functionality=PriceListDataFormat',
      { headers: headers },
    );
  } else
    result = axios.get('upload-format?app-functionality=PriceListDataFormat', {
      headers: headers,
    });
  return result;
};
export const fetchPriceListDataUploadSuccess = (data, id) => {
  return {
    type: id ? LIST_DATA_FORMAT_BY_ID : LIST_DATA_FORMAT_SUCCESS,
    data,
  };
};
export const uploadListDataFile = (id, priceListId, file, applicationType, functionality) => {
  return (dispatch) => {
    dispatch(fetchStart());
    uploadListDataFileApi(id, priceListId, file, applicationType, functionality)
      .then(async (response) => {
        dispatch(fetchEnd());
        const logNumber = response?.data?.log_number;
        if (logNumber) {
          await handleExecutionLog(dispatch, logNumber);
        }
        if (response.data.warning_message) {
          toast.success(response.data.warning_message);
          dispatch(ListDataUploadFailure([]));
        } else {
          dispatch(ListDataUploadFailure(response.data.response));
        }
      })
      .catch(async (error) => {
        dispatch(fetchEnd());
        const logNumber = error?.response?.data?.log_number;
        if (logNumber) {
          await handleExecutionLog(dispatch, logNumber);
        }
        //toast.error(error.response.data.complete_error_message);
      });
  };
};

const uploadListDataFileApi = (id, priceListId, file, applicationType, functionality) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
    'Content-Type': 'multipart/form-data;',
  };
  const extraParams =
    (applicationType ? '&application_type=' + applicationType : '') +
    (functionality ? '&functionality=' + functionality : '');
  var result;
  if (priceListId)
    result = axios.post(
      'price-list-data-upload?format_id=' +
      id +
      '&price_list_id=' +
      priceListId +
      extraParams,
      file,
      { headers: headers },
    );
  else
    result = axios.post('price-list-data-upload?format_id=' + id + extraParams, file, {
      headers: headers,
    });

  return result;
};
export const ListDataUploadFailure = (data) => {
  return {
    type: LIST_DATA_UPLOAD_FAILURE,
    data,
  };
};
// off invoice config

export const createOffInvoiceConfig = (data, type, id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    createOffInvoiceConfigAPI(data, type, id)
      .then((response) => {
        dispatch(fetchEnd());
        history.push('/pricing-offinvoice-config');
        dispatch(getOffInvoiceConfig());

        if (type == 'clear') {
          toast.success('Successfully Deleted.');
        } else {
          toast.success(response.data.response);
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const createOffInvoiceConfigAPI = (data, type, id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (type === 'create')
    result = axios.post('pricing-config', data, { headers: headers });
  else result = axios.put('pricing-config/' + id, data, { headers: headers });
  return result;
};

export const getOffInvoiceConfig = () => {
  return (dispatch) => {
    getOffInvoiceConfigAPI()
      .then((response) => {
        //dispatch(getKeyFigureableDataComplete(response.data.response.total_record));
        dispatch(getOffInvoiceConfigSuccess(response.data.response));
      })
      .catch((error) => { });
  };
};

const getOffInvoiceConfigAPI = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('/pricing-config', { headers: headers });
  return result;
};

export const getOffInvoiceConfigSuccess = (data) => {
  return {
    type: OFF_INVOICE_CONFIG_SUCCESS,
    data,
  };
};

//Configure EDI Mappings Created Data

export const getConfEdiMappings = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    getConfEdiMappingsAPI()
      .then((response) => {
        dispatch(getConfEdiMappingsSuccess(response.data.response));
        dispatch(fetchEnd());
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const getConfEdiMappingsAPI = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('edi-mappings/distinct', { headers: headers });
  return result;
};
export const getConfEdiMappingsSuccess = (data) => {
  return {
    type: CONF_EDI_MAPPINGS_SUCCESS,
    data,
  };
};

// price calculation formula
export const getPriceCalForList = (pagination, limit, type) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getPriceCalForListAPI(pagination, limit, type)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getPriceCalForListSuccess(response.data.response));
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const getPriceCalForListAPI = (pagination, limit, type) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (type == 'Price Calculation Formula' || type == 'price catalog') {
    result = axios.get(
      'pricing-calc-formula?formula_type=all&page=' +
      pagination +
      '&limit=' +
      limit,
      { headers: headers },
    );
  } else if (type == 'Price Optimization') {
    result = axios.get(
      'pricing-calc-formula?formula_type=' +
      type +
      '&page=' +
      pagination +
      '&limit=' +
      limit,
      { headers: headers },
    );
  } else {
    result = axios.get(
      'pricing-calc-formula?formula_type=sale price&page=' +
      pagination +
      '&limit=' +
      limit,
      { headers: headers },
    );
  }
  return result;
};
export const getPriceCalForListSuccess = (data) => {
  return {
    type: PRICE_CAL_FOR_LIST_SUCCESS,
    data,
  };
};

//Create EDI Mappings
export const createEDIMappings = (data, type) => {
  return (dispatch) => {
    dispatch(fetchStart());
    createEDIMappingsAPI(data, type)
      .then((response) => {
        if (type === 'get') {
          dispatch(fetchEnd());
          dispatch(getIDConfEdiMappingsSuccess(response.data.response));
        } else {
          dispatch(fetchEnd());
          history.push('/edi-mappings');
          dispatch(getConfEdiMappings());
          toast.success(response.data.response);
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const createEDIMappingsAPI = (data, type) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (type === 'delete') {
    result = axios.put('edi-mapping-data', data, { headers: headers });
  } else if (type === 'get') {
    result = axios.post('edi-mapping-data', data, { headers: headers });
  } else if (type === 'edit') {
    result = axios.put('edi-mappings', data, { headers: headers });
  } else {
    result = axios.post('edi-mappings', data, { headers: headers });
  }
  return result;
};

//Clone EDI Mappings
export const cloneEDIMapping = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    cloneEDIMappingAPI(data)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getConfEdiMappings());
        toast.success(response.data.response);
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const cloneEDIMappingAPI = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  return axios.post('edi-mappings/clone', data, { headers: headers });
};

export const getIDConfEdiMappingsSuccess = (data) => {
  return {
    type: CONF_ID_EDI_MAPPINGS_SUCCESS,
    data,
  };
};

export const createPriceCalForList = (data, id, type, applicationType) => {
  return (dispatch) => {
    dispatch(fetchStart());
    createPriceCalForListAPI(data, id, type)
      .then((response) => {
        dispatch(fetchEnd());
        if (type === 'delete')
          dispatch(getPriceCalForList(1, 100, 'Price Calculation Formula'));
        else
          history.push({
            pathname: '/pricing-calculation-formula',
            state: { application: applicationType },
          });
        newToast.showSuccess(response.data.response);
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const createPriceCalForListAPI = (data, id, type) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (type === 'edit') {
    result = axios.put('pricing-calc-formula', data, { headers: headers });
  } else if (type === 'delete') {
    result = axios.delete('pricing-calc-formula/' + id, { headers: headers });
  } else {
    result = axios.post('pricing-calc-formula', data, { headers: headers });
  }
  return result;
};

export const getPriceCalForListById = (id) => {
  return (dispatch) => {
    getPriceCalForListByIdAPI(id)
      .then((response) => {
        dispatch(getPriceCalForListByIdSuccess(response.data.response));
        // history.push('/pricing-calculation-formula/edit-formula/' + id);
      })
      .catch((error) => { });
  };
};

const getPriceCalForListByIdAPI = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('pricing-calc-formula/' + id, { headers: headers });
  return result;
};

export const getPriceCalForListByIdSuccess = (data) => {
  return {
    type: PRICE_CAL_FOR_LIST_BY_ID,
    data,
  };
};
// get priece cal formula by formula name
export const getPriceCalForListByName = (name) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getPriceCalForListByNameAPI(name)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getPriceCalForListByNameSuccess(response.data.response));
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const getPriceCalForListByNameAPI = (name) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('pricing-calc-formula?formula_name=' + name, {
    headers: headers,
  });
  return result;
};

export const getPriceCalForListByNameSuccess = (data) => {
  return {
    type: PRICE_CAL_FOR_LIST_BY_NAME,
    data,
  };
};
//PriceChangeHistory
export const getPriceChangeHistoryData = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getPriceChangeHistoryDataAPi(data)
      .then((response) => {
        dispatch(fetchEnd());
        if (response.data.response && response.data.response.length > 0) {
          dispatch(fetchEnd());
          dispatch(getPriceChangeHistoryDataSucsses(response.data.response));
          history.push('/price-change-history-results');
        } else {
          toast.warning('No records found.');
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const getPriceChangeHistoryDataAPi = (data) => {
  for (let propName in data) {
    if (
      data[propName] === '' ||
      data[propName] === null ||
      data[propName] === undefined ||
      data[propName].length === 0 ||
      data[propName] === '1970-01-01T00:00:00.000Z,1970-01-01T00:00:00.000Z' ||
      data[propName] === '1970-01-01T00:00:00.000Z' ||
      data[propName] === ','
    ) {
      delete data[propName];
    }
  }
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;

  result = axios.post('/price-change-history ', data, { headers: headers });

  return result;
};
export const getPriceChangeHistoryDataSucsses = (data) => {
  return {
    type: PRICE_CHANGE_HISTORY_DATA_SUCCESS,
    data,
  };
};

// run price calculation simulation cpq
export const runPriceCalcForSimulation = (
  data,
  type,
  form,
  simulationNo,
  formula,
) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getPriceCalcForSimulationAPi(data, type, form, simulationNo, formula)
      .then((response) => {
        dispatch(fetchEnd());
        if (type == 'price Simulation Historical and Forecast') {
          toast.success(response.data.message);
        } else if (type == 'priceCatalog') {
          if (form !== 'excel') {
            toast.success(response.data.message);
            dispatch(priceCatalogSuccess(response.data.response));
            history.push({
              pathname: '/price-catalog-results',
              formula: data.formula_name,
            });
          } else {
            const contentDisposition = response.headers['content-disposition'];
            let fileName = 'catalog.zip';

            if (
              contentDisposition &&
              contentDisposition.includes('filename=')
            ) {
              fileName = contentDisposition
                .split('filename=')[1]
                .split(';')[0]
                .replace(/['"]/g, '')
                .trim();
            }

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            link.remove();
          }
        } else if (type == 'priceAdjustmentSimulation') {
          toast.success(response.data.message);
          dispatch(priceAdjustmentSuccess(response.data.response));
          history.push({
            pathname: '/price-adjustment-simulation-results',
            formula: data.formula_procedure,
          });
        } else if (type === 'PriceSimulationReport') {
          dispatch(fetchEnd());
          toast.success(response.data.response);
          dispatch(priceCalForSimulationSuccess(response.data.response, null));
          history.push('/price-simulation-report-results');
        } else {
          dispatch(fetchEnd());
          dispatch(priceCalForSimulationSuccess(response.data.response, null));
          if (type == 'details') {
            if (form != 'edit')
              history.push('/price-simulation-detailed-quote/create-quote');
          } else if (type == 'price-policy') {
            history.push('/quote-view/' + data.id);
          } else {
            // toast.success(response.data.message)
            history.push('/price-simulation-results');
          }
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const getPriceCalcForSimulationAPi = (
  data,
  type,
  form,
  simulationNo,
  formula,
) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (type === 'PriceSimulationReport') {
    result = axios.post('pricing-calc-sim/price-type-values', data, {
      headers: headers,
    });
  } else if (type === 'priceCatalog') {
    if (form == 'excel')
      result = axios.post('pricing/catalog/download', data, {
        headers: headers,
        responseType: 'blob',
      });
    else
      result = axios.post('pricing/catalog', data, {
        headers: headers,
      });
  } else if (type === 'priceAdjustmentSimulation') {
    result = axios.post('price-optimization', data, {
      headers: headers,
    });
  } else {
    if (simulationNo) {
      if (type == 'price-policy') {
        result = axios.get(
          'pricing-calc-result?simulation_category=' +
          data.simulation_category +
          '&simulation_number=' +
          simulationNo +
          '&formula=' +
          formula +
          '&id=' +
          data.id,
          { headers: headers },
        );
      } else {
        result = axios.get(
          'pricing-calc-result?simulation_category=CPQ&simulation_number=' +
          simulationNo +
          '&formula=' +
          formula,
          { headers: headers },
        );
      }
    } else result = axios.post('pricing-calc-sim', data, { headers: headers });
  }
  return result;
};

export const priceCalForSimulationSuccess = (data, errorList) => {
  return {
    type: PRICE_CAL_FOR_SIMULATION_SUCCESS,
    data,
    errorList,
  };
};
export const priceCatalogSuccess = (data) => {
  return {
    type: PRICE_CATALOG_SUCCESS,
    data,
  };
};
export const priceAdjustmentSuccess = (data) => {
  return {
    type: PRICE_ADJUST_SUCCESS,
    data,
  };
};
export const getSimulationDropdown = (data) => {
  return (dispatch) => {
    getSimulationDropdownAPI(data)
      .then((response) => {
        toast.success(response.data.response);
        dispatch(getSimulationDropdownSuccess(response.data.response));
      })
      .catch((error) => { });
  };
};
const getSimulationDropdownAPI = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.post(
    'pricing-calc-sim/price-type-values?drop_down_value=calculation_simulation_number',
    data,
    { headers: headers },
  );
  return result;
};
export const getSimulationDropdownSuccess = (data) => {
  return {
    type: SIMULATION_DROPDOWN_SUCCESS,
    data,
  };
};
// Price Elasticity API
export const getPriceElasticity = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getPriceElasticityAPI(data)
      .then((response) => {
        dispatch(fetchEnd());
        if (response.data.response.length > 0) {
          dispatch(getPriceElasticitySuccess(response.data.response));
          history.push('/price-elasticity-results');
        } else {
          toast.warn('No records found.');
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};
const getPriceElasticityAPI = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.post('price-impact-analysis', data, { headers: headers });
  return result;
};
export const getPriceElasticitySuccess = (data) => {
  return {
    type: PRICE_ELASTICITY,
    data,
  };
};
// Price Catalog List API
export const getPriceCatalogById = (id, type) => {
  return (dispatch) => {
    getPriceCatalogByIdAPI(id, type)
      .then((response) => {
        if (type == 'delete') {
          dispatch(getPriceCatalogList())
          toast.success(response.data.response)
        }
        else {
          dispatch(priceCatalogExecutionSuccess(response.data?.response));
        }
      })
      .catch((error) => {
        //toast.error(ServerError)
      });
  };
};

const getPriceCatalogByIdAPI = (id, type) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (type === 'delete') {
    result = axios.delete('pricing/catalog/' + id, {
      headers: headers,
    });
  } else result = axios.get('pricing/catalog/' + id, { headers: headers });
  return result;
};

export const getPriceCatalogList = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    getPriceCatalogListAPI()
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getPriceCatalogListSuccess(response.data.response));
      })
      .catch((error) => {
        dispatch(fetchEnd());
        //toast.error(ServerError)
      });
  };
};

const getPriceCatalogListAPI = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('pricing/catalog', { headers: headers });
  return result;
};
export const getPriceCatalogListSuccess = (data) => {
  return {
    type: PRICE_CATALOG_LIST_DATA,
    data,
  };
};

//Price Catalog Execution API
export const priceCatalogExecution = (data, mode, type) => {
  return (dispatch) => {
    dispatch(fetchStart());
    priceCatalogExecutionAPI(data, mode, type)
      .then((response) => {
        dispatch(fetchEnd());
        if (mode == 'edit' || mode == 'view') {
          if (type !== 'commit') {
            if (response.data?.response?.data) {
              dispatch(priceCatalogExecutionSuccess(response.data?.response?.data));
              toast.success(response.data.response.status);
              history.push('/price-catalog-list');
            }
            else {
              toast.warn('No records found.');
            }
          }
          else {
            if (response.data?.response?.data) {
              dispatch(priceCatalogExecutionSuccess(response.data?.response?.data));
              toast.success(response.data.response.status);
            }
            else {
              toast.warn('No records found.');
            }
          }
        }
        else {
          if (response.data?.response?.data) {
            dispatch(priceCatalogExecutionSuccess(response.data?.response?.data));
            toast.success(response.data.response.status);
            history.push('/price-catalog-results');
          }
          else {
            toast.warn('No records found.');
          }
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};
const priceCatalogExecutionAPI = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.post('pricing/catalog', data, { headers: headers });
  return result;
};
export const priceCatalogExecutionSuccess = (data) => {
  return {
    type: PRICE_CATALOG_DATA_SUCCESS,
    data,
  };
};

//Price Simulation Execution API
export const priceSimulationExecution = (data, mode, type) => {
  return (dispatch) => {
    dispatch(fetchStart('simulationLoading'));
    return priceSimulationExecutionAPI(data, mode, type)
      .then(async (response) => {
        dispatch(fetchEnd('simulationLoading'));
        const result = response.data?.response?.data;
        const logNumber = response?.data?.log_number;
        if (result) {
          dispatch(priceSimulationExecutionSuccess(result));
          if (mode == 'edit' || mode == 'view') {
            if (type !== 'commit') history.push('/price-simulation-list');
          }
          else {
            history.push('/price-simulation-results');
          }
        }
        // The execution log carries the backend's own messages; fall back to the
        // plain toasts only when the response has no log_number.
        if (logNumber) {
          await handleExecutionLog(dispatch, logNumber);
        }
        else if (result) {
          toast.success(response.data.response.status);
        }
        else {
          toast.warn('No records found.');
        }
      })
      .catch(async (error) => {
        dispatch(fetchEnd('simulationLoading'));
        const logNumber = error?.response?.data?.log_number;
        if (logNumber) await handleExecutionLog(dispatch, logNumber);
      });
  };
};
const priceSimulationExecutionAPI = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.post('pricing/simulation', data, { headers: headers });
  return result;
};
export const priceSimulationExecutionSuccess = (data) => {
  return {
    type: PRICE_SIMULATION_DATA_SUCCESS,
    data,
  };
};
// customer margin
export const runCustomerMargin = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getCustomerMarginAPi(data)
      .then((response) => {
        dispatch(fetchEnd());
        toast.success(response.data.message);
        dispatch(customerMarginSuccess(response.data.response, null));
        history.push('/customer-margin-results');
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const getCustomerMarginAPi = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  const result = axios.get(
    'pricing-sim-result',
    { params: data, headers: headers },
  );
  return result;
};

export const customerMarginSuccess = (data, errorList) => {
  return {
    type: CUSTOMER_MARGIN_SUCCESS,
    data,
    errorList,
  };
};

// get price simulation results
export const getPriceSimResult = () => {
  return (dispatch) => {
    getPriceSimResultAPI()
      .then((response) => {
        dispatch(getPriceSimResultSuccess(response.data.response));
      })
      .catch((error) => { });
  };
};

const getPriceSimResultAPI = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('pricing-sim-result?limit=0', { headers: headers });
  return result;
};
export const getPriceSimResultSuccess = (data) => {
  return {
    type: PRICE_SIM_RESULTS_SUCCESS,
    data,
  };
};
// Market Price
export const runMarketPrice = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getMarketPriceAPi(data)
      .then((response) => {
        dispatch(fetchEnd());
        toast.success(response.data.message);
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const getMarketPriceAPi = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  const result = axios.post('pricing/market-price/calc-list-data', data, {
    headers: headers,
  });
  return result;
};
// Price Policy Exceptions
export const getPricePolicyExceptionsReport = (pagination, limit) => {
  return (dispatch) => {
    getPricePolicyExceptionsReportAPI(pagination, limit)
      .then((response) => {
        dispatch(getPricePolicyExceptionsReportSuccess(response.data.response));
      })
      .catch((error) => {
        //toast.error(ServerError)
      });
  };
};

const getPricePolicyExceptionsReportAPI = (pagination, limit) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get(
    'pricing-calc-exception?page=' + pagination + '&limit=' + limit,
    { headers: headers },
  );
  return result;
};
export const getPricePolicyExceptionsReportSuccess = (data) => {
  return {
    type: PRICE_POLICY_EXCEP,
    data,
  };
};

//Pricing simulation list
export const getPriceSimulationList = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    getPriceSimulationListAPI()
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getPriceSimulationListSuccess(response.data.response));
      })
      .catch((error) => {
        dispatch(fetchEnd());
        //toast.error(ServerError)
      });
  };
};

const getPriceSimulationListAPI = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('pricing/simulation', { headers: headers });
  return result;
};
export const getPriceSimulationListSuccess = (data) => {
  return {
    type: PRICE_SIMULATION_LIST_DATA,
    data,
  };
};

export const getPriceSimulationById = (id, type) => {
  return (dispatch) => {
    // Returned so callers can await the result - the list screen refreshes
    // itself once a delete resolves. Existing callers ignore the value.
    return getPriceSimulationByIdAPI(id, type)
      .then((response) => {
        if (type == 'delete') {
          dispatch(getPriceSimulationList())
          toast.success(response.data.response)
        }
        else {
          dispatch(priceSimulationExecutionSuccess(response.data?.response));
        }
      })
      .catch((error) => {
        //toast.error(ServerError)
      });
  };
};

const getPriceSimulationByIdAPI = (id, type) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (type === 'delete') {
    result = axios.delete('pricing/simulation/' + id, {
      headers: headers,
    });
  } else result = axios.get('pricing/simulation/' + id, { headers: headers });
  return result;
};
export const getPriceSimulationByIdSuccess = (data) => {
  return {
    type: PRICE_SIMULATION_DATA_BY_ID,
    data,
  };
};

export const onBulkApprovePriceMaintenance = (data) => {
  return (dispatch) => {
    onBulkApprovePriceMaintenanceApi(data)
      .then((response) => {
        toast.success(response.data.response);
        dispatch(getAllDistinctPriceListData(1, 0, 'approval'));
      })
      .catch((error) => {
        //toast.error(error.response.data.error.message);
      });
  };
};
const onBulkApprovePriceMaintenanceApi = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.put('price-list-bulk-approval', data, { headers: headers });
  return result;
};

export const getUniquePriceData = (name) => {
  return (dispatch) => {
    getUniquePriceDataApi()
      .then((response) => {
        //if(name=='price_list_id')
        dispatch(getUniquePriceDataSuccess(response.data.response));
      })
      .catch((error) => {
        //toast.error(error.response.data.error.message);
      });
  };
};
const getUniquePriceDataApi = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('distinct-price-list-names', { headers: headers });
  return result;
};

export const getUniquePriceDataSuccess = (data) => {
  return {
    type: PRICE_UNIQUE_SUCCESS,
    data,
  };
};

export const getPriceFilterData = (data) => {
  return (dispatch) => {
    getPriceFilterDataAPI(data)
      .then((response) => {
        dispatch(getPriceFilterDataSuccess(response.data.response));
        // history.push('/pricing-maintenance/edit-list-data/' + id);
      })
      .catch((error) => { });
  };
};

const getPriceFilterDataAPI = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.post('pricing/price-list/filters', data, { headers: headers });
  return result;
};

export const getPriceFilterDataSuccess = (data) => {
  return {
    type: PRICE_FILTER_DATA,
    data,
  };
};

export const getPriceCatalogFilter = (formula) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getPriceCatalogFilterAPI(formula)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getPriceCatalogFilterSuccess(response.data.response));
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const getPriceCatalogFilterAPI = (formula) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('price-catalog-qualifier-names?formula_name=' + formula, {
    headers: headers,
  });
  return result;
};

export const getPriceCatalogFilterSuccess = (data) => {
  return {
    type: CATALOG_FILTER_DATA,
    data,
  };
};
// Price Simulation Configuration
export const createPriceSimulationConfig = (data, id, type, applicationType) => {
  return (dispatch) => {
    dispatch(fetchStart());
    createPriceSimulationConfigAPI(data, id, type)
      .then((response) => {
        dispatch(fetchEnd());
        if (type === 'delete') {
          dispatch(getPriceSimulationConfig())
        }
        else {
          history.push({
            pathname: '/profile-configuration',
            state: { application: applicationType },
          })
        };
        toast.success(response.data.message);
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const createPriceSimulationConfigAPI = (data, id, type) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (type === 'edit') {
    result = axios.put('pricing/simulation-config/' + id, data, {
      headers: headers,
    });
  } else if (type === 'delete') {
    result = axios.delete('pricing/simulation-config/' + id, {
      headers: headers,
    });
  } else {
    result = axios.post('pricing/simulation-config', data, {
      headers: headers,
    });
  }
  return result;
};

export const getPriceSimulationConfigById = (id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getPriceSimulationConfigByIdAPI(id)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getPriceSimulationConfigByIdSuccess(response.data.response));
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const getPriceSimulationConfigByIdAPI = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('pricing/simulation-config/' + id, { headers: headers });
  return result;
};

export const getPriceSimulationConfigByIdSuccess = (data) => {
  return {
    type: PRICE_SIMULATION_CONFIG_BY_ID,
    data,
  };
};

export const getPriceSimulationConfig = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getPriceSimulationConfigAPI(data)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(
          getPriceSimulationConfigSuccess(response.data.response || []),
        );
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const getPriceSimulationConfigAPI = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (data) {
    return axios.get('pricing/simulation-config', {
      headers: headers,
      params: data ? { simulation_type: data } : {}
    });
  }
  else {
    result = axios.get('pricing/simulation-config', {
      headers: headers,
    });
  }
  return result;
};
export const getPriceSimulationConfigSuccess = (data) => {
  return {
    type: PRICE_SIMULATION_CONFIG_SUCCESS,
    data,
  };
};

// Price Catalog Configuration
export const createPriceCatalogConfig = (data, id, type, applicationType) => {
  return (dispatch) => {
    dispatch(fetchStart());
    createPriceCatalogConfigAPI(data, id, type)
      .then((response) => {
        dispatch(fetchEnd());
        if (type === 'delete') {
          dispatch(getPriceCatalogConfig())
        }
        else {
          history.push({
            pathname: '/price-catalog-configuration-list',
            state: { application: applicationType },
          })
        };
        toast.success(response.data.message);
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const createPriceCatalogConfigAPI = (data, id, type) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (type === 'edit') {
    result = axios.put('pricing/catalog-config/' + id, data, {
      headers: headers,
    });
  } else if (type === 'delete') {
    result = axios.delete('pricing/catalog-config/' + id, {
      headers: headers,
    });
  } else {
    result = axios.post('pricing/catalog-config', data, {
      headers: headers,
    });
  }
  return result;
};

export const getPriceCatalogConfigById = (id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getPriceCatalogConfigByIdAPI(id)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getPriceCatalogConfigByIdSuccess(response.data.response));
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const getPriceCatalogConfigByIdAPI = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('pricing/catalog-config/' + id, { headers: headers });
  return result;
};

export const getPriceCatalogConfigByIdSuccess = (data) => {
  return {
    type: PRICE_CATALOG_CONFIG_BY_ID,
    data,
  };
};

export const getPriceCatalogConfig = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getPriceCatalogConfigAPI(data)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(
          getPriceCatalogConfigSuccess(response.data.response || []),
        );
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const getPriceCatalogConfigAPI = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (data) {
    return axios.get('pricing/catalog-config', {
      headers: headers,
      params: data ? { catalog_type: data } : {}
    });
  }
  else {
    result = axios.get('pricing/catalog-config', {
      headers: headers,
    });
  }
  return result;
};
export const getPriceCatalogConfigSuccess = (data) => {
  return {
    type: PRICE_CATALOG_CONFIG_SUCCESS,
    data,
  };
};

//Price Request config
export const createPriceRequestConfig = (data, id, type) => {
  return (dispatch) => {
    dispatch(fetchStart());
    createPriceRequestConfigAPI(data, id, type)
      .then((response) => {
        dispatch(fetchEnd());
        if (type === 'delete') dispatch(getPriceRequestConfig());
        else history.push('/pricing-request-config');
        toast.success(response.data.response);
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const createPriceRequestConfigAPI = (data, id, type) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (type === 'edit') {
    result = axios.put('pricing/price-request-type/' + id, data, {
      headers: headers,
    });
  } else if (type === 'delete') {
    result = axios.delete('pricing/price-request-type/' + id, {
      headers: headers,
    });
  } else {
    result = axios.post('pricing/price-request-type', data, {
      headers: headers,
    });
  }
  return result;
};

export const getPriceRequestConfigById = (id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getPriceRequestConfigByIdAPI(id)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getPriceRequestConfigByIdSuccess(response.data.response));
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const getPriceRequestConfigByIdAPI = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('pricing/price-request-type/' + id, { headers: headers });
  return result;
};

export const getPriceRequestConfigByIdSuccess = (data) => {
  return {
    type: PRICE_REQUEST_CONFIG_BY_ID,
    data,
  };
};

export const getPriceRequestConfig = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    getPriceRequestConfigAPI()
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(
          getPriceRequestConfigSuccess(response.data.response?.records || []),
        );
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const getPriceRequestConfigAPI = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('pricing/price-request-type?page=1&limit=100', {
    headers: headers,
  });
  return result;
};
export const getPriceRequestConfigSuccess = (data) => {
  return {
    type: PRICE_REQUEST_CONFIG_SUCCESS,
    data,
  };
};

export const getPriceRequestTypeByFilter = (data) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const headers = { Authorization: secureLocalStorage.getItem('aTk') };
      const response = await axios.post('pricing/price-request-type/filter', data, { headers });
      dispatch(fetchEnd());
      return response.data.response || [];
    } catch (error) {
      dispatch(fetchEnd());
      return [];
    }
  };
};

// list api
export const getPriceReasonCodeConfig = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    getPriceReasonCodeConfigAPI()
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getPriceReasonCodeConfigSuccess(response.data.response));
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const getPriceReasonCodeConfigAPI = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('pricing/price-reason-codes?page=1&limit=100', {
    headers: headers,
  });
  return result;
};
export const getPriceReasonCodeConfigSuccess = (data) => {
  return {
    type: PRICE_REASON_CODE_CONFIG_SUCCESS,
    data,
  };
};

//pricing requests list

export const pricingRequestsList = (filters) => {
  return (dispatch) => {
    dispatch(fetchStart());
    pricingRequestsListAPI()
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(pricingRequestsListSuccess(response.data.response));
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};
export const pricingRequestsListSuccess = (data) => {
  return {
    type: PRICE_REQUESTS_LIST_SUCCESS,
    data,
  };
};
const pricingRequestsListAPI = (data, id, type) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.put('pricing/price-requests/' + id, data, {
    headers: headers,
  });
  return result;
};

export const pricingRequestsListByID = (id) => {
  return (dispatch) => {
    getPriceFormulaByIdAPI(id)
      .then((response) => {
        dispatch(pricingRequestsListByIDSuccess(response.data.response));
      })
      .catch((error) => { });
  };
};

export const pricingRequestsListByIDSuccess = (data) => {
  return {
    type: PRICE_REQUESTS_LIST_ID_SUCCESS,
    data,
  };
};

//price requests
export const pricingRequests = (filters) => {
  return (dispatch) => {
    dispatch(pricingRequestsSuccess([], true));
    pricingRequestAPI()
      .then((response) => {
        dispatch(pricingRequestsSuccess(response.data.response, false));
      })
      .catch((error) => {
        dispatch(pricingRequestsSuccess([], false));
      });
  };
};
export const pricingRequestsSuccess = (data, loader) => {
  return {
    type: PRICE_REQUESTS_SUCCESS,
    data,
    loader
  };
};
const pricingRequestAPI = (data, id, type) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.post('pricing/price-requests', { headers: headers });
  return result;
};

// skipNavigation lets a caller fetch into priceRequestDetail without the real history.push.
export const getPriceRequstByID = (id, type, skipNavigation) => {
  return (dispatch) => {
    getPriceRequstByIDAPI(id)
      .then((response) => {
        //console.log('here', response.data.response);
        dispatch(getPriceRequstByIDSuccess(response.data.response));

        if (skipNavigation) return;
        if (response.data.status == '200' || response.data.status == '201')
          if (type === 'view') history.push('/pricing-requests/view/' + id);
          else history.push('/pricing-requests/edit/' + id);
      })
      .catch((error) => { });
  };
};

const getPriceRequstByIDAPI = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result = axios.get(
    `pricing/price-request/${id}?application_type=${sessionStorage.getItem('application')}`,
    { headers: headers },
  );
  return result;
};

export const getPriceRequstByIDSuccess = (data) => {
  return {
    type: PRICE_REQUESTS_BY_ID_SUCCESS,
    data,
  };
};

export const createPriceListValidate = (data, priceListId, contractId) => {
  return (dispatch) => {
    return createPriceListValidateAPI(data, priceListId, contractId)
      .then((response) => {
        toast.success(response.data.response);
        return response;
      })
      .catch((error) => {
        // toast.error('Validation failed. Please check your data.');
        throw error;
      });
  };
};

const createPriceListValidateAPI = (data, priceListId, contractId) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  if (sessionStorage.getItem('application') == 'Profit Optimization')
    var result = axios.put('profit-analysis-level-data', data, {
      headers: headers,
    });
  else {
    const contractIdParam = contractId ? '&contract_id=' + contractId : '';
    var result = axios.post('pricing/price-request/validate?price_list_id=' + priceListId + contractIdParam, data, {
      headers: headers,
    });
  }
  return result;
};

// Pricing Contracts

export const getPricingContractList = (id, type, params) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getPricingContractListAPI(id, type, params)
      .then((response) => {
        dispatch(fetchEnd());
        const raw = response.data;
        const contract = raw?.response ?? raw;
        dispatch(
          getPricingContractListSuccess(contract, id, type),
        );
        if (type == 'view') {
          history.push('pricing-contract/view/' + id);
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const getPricingContractListAPI = (id, type, params) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (type == 'allContracts')
    result = axios.get('/pricing/contracts', { params, headers: headers });
  else if (id)
    result = axios.get('/pricing/contracts/' + id, { headers: headers });
  else
    result = axios.get(
      '/pricing/contract-list?application_type=' +
      sessionStorage.getItem('application'),
      { headers: headers },
    );
  return result;
};
export const getPricingContractListSuccess = (data, id, type) => {
  if (type == 'allContracts')
    return {
      type: PRICE_CONTRACTS,
      data,
    };
  else if (id)
    return {
      type: PRICE_CONTRACT_ID,
      data,
    };
  else
    return {
      type: PRICE_CONTRACTS_LIST,
      data,
    };
};

/** Clear current contract data in Redux to avoid showing cached notes/attachments when navigating to another contract (edit/view). */
export const clearPriceContractId = () => ({
  type: PRICE_CONTRACT_ID,
  data: {},
});

export const createPriceContracts = (data, id, type) => {
  return (dispatch) => {
    dispatch(fetchStart());
    return createPriceContractsAPI(data, id, type)
      .then((response) => {
        dispatch(fetchEnd());
        if (type === 'delete') {
          dispatch(getPricingContractList());
          toast.success(response.data.response || 'Contract deleted successfully');
          return { success: true, response };
        }
        toast.success(response.data.response || 'Contract saved successfully');
        return { success: true, response };
      })
      .catch((error) => {
        dispatch(fetchEnd());
        const errorMessage = error?.response?.data?.message ||
          error?.response?.data?.response ||
          error?.message ||
          'Failed to save contract. Please try again.';
        toast.error(errorMessage);
        return { success: false, error };
      });
  };
};

const createPriceContractsAPI = (data, id, type) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (type === 'edit') {
    result = axios.put('/pricing/contracts/' + id, data, { headers: headers });
  } else if (type === 'delete') {
    result = axios.delete('/pricing/contracts/' + id, { headers: headers });
  } else {
    result = axios.post('/pricing/contracts', data, { headers: headers });
  }
  return result;
};

//pending contract
export const createPendingContract = (data, id, page) => {
  return (dispatch) => {
    dispatch(fetchStart());
    return createPendingContractAPI(data, id, page)
      .then((response) => {
        dispatch(fetchEnd());
        toast.success(response.data.response || 'Pending contract created successfully');
        return { success: true, response };
      })
      .catch((error) => {
        dispatch(fetchEnd());
        const errorMessage = error?.response?.data?.message ||
          error?.response?.data?.response ||
          error?.message ||
          'Failed to create pending contract. Please try again.';
        toast.error(errorMessage);
        return { success: false, error };
      });
  };
};

const createPendingContractAPI = (data, id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.post('/pricing/contracts/' + id + '/update-request', data, {
    headers: headers,
  });
  return result;
};

//confirm Pending Contract
export const confirmPendingContract = (data, id, status, page) => {
  return (dispatch) => {
    dispatch(fetchStart());
    return confirmPendingContractAPI(data, id, status, page)
      .then((response) => {
        dispatch(fetchEnd());
        toast.success(response.data.response || 'Contract confirmed successfully');
        return { success: true, response };
      })
      .catch((error) => {
        dispatch(fetchEnd());
        const errorMessage = error?.response?.data?.message ||
          error?.response?.data?.response ||
          error?.message ||
          'Failed to confirm pending contract. Please try again.';
        toast.error(errorMessage);
        return { success: false, error };
      });
  };
};

const confirmPendingContractAPI = (data, id, status) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.post(
    '/pricing/contracts/' +
    id +
    '/update-request/' +
    status +
    '?application_type=' +
    sessionStorage.getItem('application'),
    data,
    { headers: headers },
  );
  return result;
};
export const getCustomTableFields = (id) => {
  return (dispatch) => {
    getCustomTableFieldsAPI(id)
      .then((response) => {
        dispatch(getCustomTableFieldsSuccess(response.data.response));
      })
      .catch((error) => {
        console.error('Failed to fetch table fields:', error);
        // Optional: dispatch error action
      });
  };
};
const getCustomTableFieldsAPI = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };

  return axios.get(`/mdm/custom-table/${id}/fields`, { headers });
};
export const getCustomTableFieldsSuccess = (data) => {
  return {
    type: CUSTOM_TABLE_FIELDS_SUCCESS,
    data,
  };
};

//Get Configuration for Global Contract Type bY id
export const getGlobalContractConfigurationByContractType = (type, contractType) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getGlobalContractConfigurationByContractTypeAPI(type, contractType)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getGlobalContractConfigurationByContractTypeSuccess(response.data.response));
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const getGlobalContractConfigurationByContractTypeAPI = (type, contractType) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (contractType) {
    result = axios.get('contract/config-contract-type?contract_type=' + contractType, {
      headers: headers,
    });
  }
  else {
    result = axios.get('contract/config-contract-type?application_type=' + type, {
      headers: headers,
    });
  }
  return result;
};

export const getGlobalContractConfigurationByContractTypeSuccess = (data) => {
  return {
    type: GLOBAL_CONTRACT_CONFIG_BY_CONTRACT_TYPE,
    data,
  };
};

/** Clear contract type config in Redux so add page loads fresh (no cached contract type dropdown). */
export const clearGlobalContractConfigContractType = () =>
  getGlobalContractConfigurationByContractTypeSuccess([]);

//Get Configuration for Global Contract
export const getGlobalContractConfigurationByAppType = (type, functionality, params, queryParams) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getGlobalContractConfigurationByAppTypeAPI(type, functionality, params, queryParams)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getGlobalContractConfigurationByAppTypeSuccess(response.data.response));
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const getGlobalContractConfigurationByAppTypeAPI = (type, functionality, params, queryParams) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (functionality === 'apptype') {
    result = axios.get('contract/config-profile?application_type=' + type, {
      headers: headers,
    });
  } else if (functionality === 'GPO') {
    result = axios.get(`contract/config-profile?application_type=${type}&functionality=${functionality}`, {
      headers: headers,
    });
  }
  else if (params) {
    result = axios.get(`contract/config-profile`, {
      headers: headers,
      params: params
    });
  }
  else {
    const query = new URLSearchParams({ profile: type });
    if (queryParams?.functionality) query.append('functionality', queryParams.functionality);
    if (queryParams?.application_type) query.append('application_type', queryParams.application_type);
    result = axios.get(`contract/config-profile?${query.toString()}`, { headers });
  }
  return result;
};

export const getGlobalContractConfigurationByAppTypeSuccess = (data) => {
  return {
    type: GLOBAL_CONTRACT_CONFIG_BY_APP_TYPE,
    data,
  };
};

export const clearGlobalContractConfigData = () =>
  getGlobalContractConfigurationByAppTypeSuccess(null);

export const getPriceAttributes = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getPriceAttributesAPI(data)
      .then((response) => {
        dispatch(fetchEnd());
        sessionStorage.setItem('dataGridMetaDataRequest', 'false');
        dispatch(getPriceAttributesSuccess(response.data.response));
      })
      .catch((error) => {
        dispatch(fetchEnd());
        sessionStorage.setItem('dataGridMetaDataRequest', 'false');

      });
  };
};

const getPriceAttributesAPI = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (data)
    result = axios.post('mdm/attribute-labels', data, {
      headers: headers,
    });
  else
    result = axios.post('mdm/attribute-labels', {
      headers: headers,
    });
  return result;
};

export const getPriceAttributesSuccess = (data) => {
  return {
    type: PRICE_NEW_QUALIFIER_NAME_SUCCESS,
    data,
  };
};

export const clearPriceAttributes = () => getPriceAttributesSuccess({});

// Pricing Contract Approval

export const getPricingContractApproval = (limit, applicationType, data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getPricingContractApprovalAPI(limit, applicationType, data)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getPricingContractApprovalSuccess(response.data));
      })
      .catch((error) => {
        dispatch(getPricingContractApprovalSuccess([]))
        dispatch(fetchEnd());
      });
  };
};

const getPricingContractApprovalAPI = (limit, applicationType, data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (data) {
    result = axios.post('config/workflow-mass-approval-data', data, {
      headers: headers,
    });
  } else
    result = axios.get(
      '/pricing/contracts?approval_status=submit_approval&&limit=' +
      limit +
      '&application_type=' +
      applicationType,
      { headers: headers },
    );
  return result;
};
export const getPricingContractApprovalSuccess = (data) => {
  return {
    type: PRICE_CONTRACT_APPROVAL,
    data,
  };
};

//bulk approval Pricing

export const batchApprovePricing = (data, status, dataApproved, comment) => {
  return (dispatch) => {
    batchApprovePricingApi(data, status, dataApproved, comment)
      .then((response) => {
        if (
          response &&
          response.data &&
          response.data.response &&
          response.data.response.message
        ) {
          toast.success(response.data.response.message);
        }
        sessionStorage.setItem('ApproveContractPRC', false);
        dispatch(
          getPricingContractApproval(0, sessionStorage.getItem('application')),
        );
      })
      .catch((error) => {
        sessionStorage.setItem('ApproveContractPRC', false);
      });
  };
};

const batchApprovePricingApi = (data, status, dataApproved, comment) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var formData = {
    contract_ids: data,
    approval_status: status,
    update_contract_ids: dataApproved,
    notes: comment,
  };
  var result;
  result = axios.post(
    'approval-request/bulk-approval/pricing_contract?application_type=' +
    sessionStorage.getItem('application'),
    formData,
    { headers: headers },
  );
  return result;
};

// price maintenance fields

export const getPriceMaintenanceFieldsNew = (priceListId, usage, functionality) => {
  return (dispatch) => {
    getPriceMaintenanceFieldsNewAPI(priceListId, usage, functionality)
      .then((response) => {
        dispatch(getPriceMaintenanceFieldsNewSuccess(response.data.response));
      })
      .catch((error) => { });
  };
};

const getPriceMaintenanceFieldsNewAPI = (priceListId, usage, functionality) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (priceListId)
    result = axios.get(
      'pricing/price-list/fields?price_list_id=' +
      priceListId +
      '&format_creation=true',
      {
        headers: headers,
      },
    );
  else
    result = axios.get(
      'pricing/price-list/fields?format_creation=true&&application_type=' +
      sessionStorage.getItem('application') +
      (usage ? '&usage=' + usage : '') +
      (functionality ? '&functionality=' + functionality : ''),
      {
        headers: headers,
      },
    );
  return result;
};

export const getPriceMaintenanceFieldsNewSuccess = (data) => {
  return {
    type: PRICE_MAINTENANCE_FIELDS_NEW,
    data,
  };
};

// get workflow name

export const getWorkflowNameData = (data, type) => {
  return (dispatch) => {
    getWorkflowStatusDataSuccess([]);
    dispatch(fetchStart());
    getWorkflowNameDataAPI(data, type)
      .then((response) => {
        dispatch(fetchEnd());
        if (type === 'status')
          dispatch(getWorkflowStatusDataSuccess(response.data.response));
        else if (type === 'nextStatus')
          dispatch(getWorkflowNextStatusDataSuccess(response.data.response));
        else dispatch(getWorkflowNameDataSuccess(response.data.response));
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const getWorkflowNameDataAPI = (data, type) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (type === 'status' || type === 'nextStatus')
    result = axios.post('config/approval-workflow/status', data, {
      headers: headers,
    });
  else
    result = axios.post('config/approval-workflows', data, {
      headers: headers,
    });
  return result;
};
export const getWorkflowNameDataSuccess = (data) => {
  return {
    type: PRICE_WORKFLOW_NAME_SUCCESS,
    data,
  };
};

export const getWorkflowStatusDataSuccess = (data) => {
  return {
    type: PRICE_WORKFLOW_STATUS_SUCCESS,
    data,
  };
};

export const getWorkflowNextStatusDataSuccess = (data) => {
  return {
    type: PRICE_WORKFLOW_NEXT_STATUS_SUCCESS,
    data,
  };
};

export const clearWorkflowStatusData = () => (dispatch) => {
  dispatch({ type: CLEAR_WORKFLOW_STATUS_DATA });
};

//mass approval

export const batchApprovalCommon = (formData, queryId) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await batchApprovalCommonApi(formData);
      dispatch(fetchEnd());

      const logNumber = response?.data?.log_number;
      if (logNumber) {
        const { hasError } = await handleExecutionLog(dispatch, logNumber);
        return { success: !hasError, response };
      }
      return { success: true, response };
    } catch (error) {
      dispatch(fetchEnd());
      const logNumber = error?.response?.data?.log_number;
      if (logNumber) {
        const { hasError } = await handleExecutionLog(dispatch, logNumber);
        return { success: !hasError };
      }
      // Deliberately not rethrown: MassApprovalComponent chains .then() on this
      // thunk to refresh its query, and that refresh should still run when the
      // approval reported errors through the execution log.
      return { success: false };
    }
  };
};

const batchApprovalCommonApi = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  return axios.post('workflow/mass-approval', data, { headers });
};

//pricing profile selection

export const getPriceProfileSelection = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    getPriceProfileSelectionAPI()
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getPriceProfileSelectionSuccess(response.data.response));
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const getPriceProfileSelectionAPI = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('pricing/profile-selection', {
    headers: headers,
  });
  return result;
};
export const getPriceProfileSelectionSuccess = (data) => {
  return {
    type: PRICE_PROFILE_SELECTION_SUCCESS,
    data,
  };
};

//pricing profile selection CRUD

export const createPriceProfileSelection = (data, id, type) => {
  return (dispatch) => {
    dispatch(fetchStart());
    createPriceProfileSelectionAPI(data, id, type)
      .then((response) => {
        dispatch(fetchEnd());
        if (type === 'delete') dispatch(getPriceProfileSelection());
        else history.push('/pricing-profile-selection');
        toast.success(response.data.response.message);
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const createPriceProfileSelectionAPI = (data, id, type) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (type === 'edit') {
    result = axios.put('pricing/profile-selection/' + id, data, {
      headers: headers,
    });
  } else if (type === 'delete') {
    result = axios.delete('pricing/profile-selection/' + id, {
      headers: headers,
    });
  } else {
    result = axios.post('pricing/profile-selection', data, {
      headers: headers,
    });
  }
  return result;
};

export const getPriceProfileSelectionById = (id) => {
  return (dispatch) => {
    getPriceProfileSelectionByIdAPI(id)
      .then((response) => {
        dispatch(getPriceProfileSelectionByIdSuccess(response.data.response));
        // history.push('/pricing-profile-selection/edit' + id);
      })
      .catch((error) => { });
  };
};

const getPriceProfileSelectionByIdAPI = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('pricing/profile-selection/' + id, { headers: headers });
  return result;
};

export const getPriceProfileSelectionByIdSuccess = (data) => {
  return {
    type: PRICE_PROFILE_SELECTION_BY_ID,
    data,
  };
};

export const getPriceProfileSelectionAttributes = (id) => {
  return (dispatch) => {
    getPriceProfileSelectionAttributesAPI(id)
      .then((response) => {
        dispatch(
          getPriceProfileSelectionAttributesSuccess(response.data.response),
        );
        // history.push('/pricing-profile-selection/edit' + id);
      })
      .catch((error) => { });
  };
};

const getPriceProfileSelectionAttributesAPI = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('pricing/profile-selection/attribute/' + id, {
    headers: headers,
  });
  return result;
};

export const getPriceProfileSelectionAttributesSuccess = (data) => {
  return {
    type: PRICE_PROFILE_SELECTION_ATTRIBUTES,
    data,
  };
};

//// Quote Configuration CRUD///////

////////////////// Layout data //////////////////////////////

export const getLayoutData = (id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getLayoutDataAPI()
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getLayoutDataSuccess(response.data.response));
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const getLayoutDataAPI = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('config-layouts', {
    headers: headers,
  });
  return result;
};
export const getLayoutDataSuccess = (data) => {
  return {
    type: LAYOUT_DATA_SUCCESS,
    data,
  };
};

//get  Approval statuses
export const fetchWorkflowStatus = (data, type) => {
  return (dispatch) => {
    fetchWorkflowStatusAPI(data, type)
      .then((response) => {
        dispatch(fetchWorkflowStatusSuccess(response.data.response));
      })
      .catch((error) => { });
  };
};

const fetchWorkflowStatusAPI = (data, type) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.post('config/approval-workflow/status', data, {
    headers: headers,
  });

  return result;
};

export const fetchWorkflowStatusSuccess = (data) => {
  return {
    type: WORKFLOW_STATUS,
    data,
  };
};

//pricing Contract Records

export const getPricingContractData = (data, id, type) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getPricingContractDataAPI(data, id, type)
      .then((response) => {
        dispatch(fetchEnd());
        toast.success(response.data.response);
        // console.log('response', response.data);
        if (type === 'fetch') {
          history.push({
            pathname: '/pricing-contract/pricing-mass-contract-update/result',
            data: {
              updateType: data.update_type,
            },
          });
          dispatch(getPricingContractDataAPISuccess(response.data));
        } else
          dispatch(getPricingContractDataAPISuccess(response.data.response));
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const getPricingContractDataAPI = (data, id, type) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (type === 'fetch' && data)
    result = axios.post('/pricing/contracts/records', data, {
      headers: headers,
    });
  else
    result = axios.get('pricing/contracts/fields', {
      headers: headers,
    });
  return result;
};

export const getPricingContractDataAPISuccess = (data) => {
  return {
    type: PRICE_CONTRACT_FIELDS,
    data,
  };
};

// mass update pricing contract

export const updatePricingMassContract = (data, type) => {
  return (dispatch) => {
    dispatch(fetchStart());
    updatePricingMassContractAPI(data, type)
      .then((response) => {
        dispatch(fetchEnd());
        // console.log('response', response.data);
        if (
          response.data &&
          response.data.updated_contract_numbers &&
          response.data.updated_contract_numbers.length > 0
        )
          toast.success(
            `Contracts '${response.data.updated_contract_numbers.join(', ')}' updated successfully`,
          );
        if (
          response.data &&
          response.data.failed_contract_numbers &&
          Object.keys(response.data.failed_contract_numbers).length > 0
        )
          toast.error(
            `Contracts '${Object.keys(response.data.failed_contract_numbers).join(', ')}' failed to update`,
          );
        history.push('/pricing-contract/pricing-mass-contract-update');
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const updatePricingMassContractAPI = (data, type) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.put('pricing/contracts/mass-update', data, {
    headers: headers,
  });
  return result;
};

//Layout Configuration

export const getPriceLayout = (id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getPriceLayoutAPI(id)
      .then((response) => {
        dispatch(fetchEnd());
        if (id) dispatch(getPriceLayoutByIdSuccess(response.data.response));
        else dispatch(getPriceLayoutSuccess(response.data.response));
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const getPriceLayoutAPI = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (id)
    result = axios.get('config-layout/' + id, {
      headers: headers,
    });
  else
    result = axios.get('config-layouts', {
      headers: headers,
    });
  return result;
};

export const getPriceLayoutSuccess = (data) => {
  return {
    type: PRICE_LAYOUT_SUCCESS,
    data,
  };
};

export const getPriceLayoutByIdSuccess = (data) => {
  return {
    type: PRICE_LAYOUT_BY_ID_SUCCESS,
    data,
  };
};

//Layout Configuration CRUD

export const createPriceLayout = (data, id, type) => {
  return (dispatch) => {
    dispatch(fetchStart());
    createPriceLayoutAPI(data, id, type)
      .then((response) => {
        dispatch(fetchEnd());
        if (type === 'delete') dispatch(getPriceLayout());
        else history.push('/pricing-layout-config');
        toast.success(response.data.message);
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const createPriceLayoutAPI = (data, id, type) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (type === 'edit') {
    result = axios.put('config-layout/' + id, data, {
      headers: headers,
    });
  } else if (type === 'delete') {
    result = axios.delete('config-layout/' + id, {
      headers: headers,
    });
  } else {
    result = axios.post('config-layout', data, {
      headers: headers,
    });
  }
  return result;
};

//Profile Configuration

export const getPriceProfileConfiguration = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    getPriceProfileConfigurationAPI()
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getPriceProfileConfigurationSuccess(response.data.response));
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const getPriceProfileConfigurationAPI = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('pricing/profile-config', {
    headers: headers,
  });
  return result;
};
export const getPriceProfileConfigurationSuccess = (data) => {
  return {
    type: PRICE_PROFILE_CONFIGURATION_SUCCESS,
    data,
  };
};

//Profile Configuration CRUD

export const createPriceProfileConfiguration = (data, id, type) => {
  return (dispatch) => {
    dispatch(fetchStart());
    return createPriceProfileConfigurationAPI(data, id, type)
      .then((response) => {
        dispatch(fetchEnd());
        const successMessage = response?.data?.message
        if (type === 'delete') {
          dispatch(getPriceProfileConfiguration());
          newToast.showSuccess(successMessage);
        } else {
          history.push('/pricing-profile-config', {
            toastMessage: successMessage,
            toastType: 'success',
          });
        }
        return response.data;
      })
      .catch((error) => {
        dispatch(fetchEnd());

      });
  };
};

const createPriceProfileConfigurationAPI = (data, id, type) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (type === 'edit') {
    result = axios.put('pricing/profile-config/' + id, data, {
      headers: headers,
    });
  } else if (type === 'delete') {
    result = axios.delete('pricing/profile-config/' + id, {
      headers: headers,
    });
  } else {
    result = axios.post('pricing/profile-config', data, {
      headers: headers,
    });
  }
  return result;
};

export const getPriceProfileConfigurationById = (id, params) => {
  return (dispatch) => {
    dispatch(fetchStart());
    dispatch(getPriceProfileConfigurationByIdSuccess(null, true));
    getPriceProfileConfigurationByIdAPI(id, params)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(
          getPriceProfileConfigurationByIdSuccess(
            response.data.response,
            false,
          ),
        );
      })
      .catch((error) => {
        dispatch(fetchEnd());
        dispatch(getPriceProfileConfigurationByIdSuccess(null, false));
      });
  };
};

const getPriceProfileConfigurationByIdAPI = (id, params) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (params)
    result = axios.get('pricing/profile-config/by-type-name', { headers: headers, params: params });
  else
    result = axios.get('pricing/profile-config/' + id, { headers: headers })
  return result;
};

export const getPriceProfileConfigurationByIdSuccess = (data, loader) => {
  return {
    type: PRICE_PROFILE_CONFIGURATION_BY_ID,
    data,
    loader,
  };
};
export const getPriceLayoutByQuote = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    return getPriceLayoutByQuoteAPI(data).then((response) => {
      dispatch(fetchEnd());
      dispatch(getPriceLayoutByQuoteSuccess(response.data.response));
      return response.data.response;
    }).catch((error) => {
      dispatch(fetchEnd());
      console.error('Error fetching layout data:', error);
      throw error;
    });
  };
};

const getPriceLayoutByQuoteAPI = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.post('layout-data', data, { headers: headers });
  return result;
};

export const getPriceLayoutByQuoteSuccess = (data) => {
  return {
    type: PRICE_LAYOUT_BY_QUOTE_SUCCESS,
    data,
  };
};

// Get Layout by Document ID (new API)
export const getLayoutByDocumentId = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    return getLayoutByDocumentIdAPI(data).then((response) => {
      dispatch(fetchEnd());
      dispatch(getLayoutByDocumentIdSuccess(response.data.response));
      return response.data.response;
    }).catch((error) => {
      dispatch(fetchEnd());
      console.error('Error fetching layout data by document ID:', error);
      throw error;
    });
  };
};

const getLayoutByDocumentIdAPI = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.post('execute/layout', data, { headers: headers });
  return result;
};

export const getLayoutByDocumentIdSuccess = (data) => {
  return {
    type: PRICE_LAYOUT_BY_DOCUMENT_SUCCESS,
    data,
  };
};

// Price Points Actions
export const getPricePoints = (applicationType) => {
  return (dispatch) => {
    dispatch(fetchStart());

    return getPricePointsAPI(applicationType)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getPricePointsSuccess(response.data.response));
        return response.data.response;
      })
      .catch((error) => {
        dispatch(fetchEnd());
        console.error('Error fetching price points:', error);
        throw error;
      });
  };
};

const getPricePointsAPI = (applicationType) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };

  const params = {};
  if (applicationType) {
    params.application_type = applicationType;
  }

  return axios.get('price-points', { headers: headers, params });
};

// History Actions
export const getPriceHistory = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());

    return getHistoryAPI(data)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getHistorySuccess(response.data.response));
        return response.data.response;
      })
      .catch((error) => {
        dispatch(fetchEnd());
        console.error('Error fetching history:', error);
        throw error;
      });
  };
};

const getHistoryAPI = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };

  return axios.post('history/price-point-header', { ...data }, { headers: headers });
};

export const getHistorySuccess = (data) => {
  return {
    type: PRICE_HISTORY_SUCCESS,
    data
  };
};

// History By ID Actions
export const getPriceHistoryByID = (id) => {
  return (dispatch) => {
    dispatch(fetchStart());

    return getHistoryByIDAPI(id)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getHistoryByIDSuccess(response.data.response));
        return response.data.response;
      })
      .catch((error) => {
        dispatch(fetchEnd());
        console.error('Error fetching history by ID:', error);
        throw error;
      });
  };
};

const getHistoryByIDAPI = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };

  return axios.get(`history/price-point-details/${id}`, { headers: headers });
};

export const getHistoryByIDSuccess = (data) => {
  return {
    type: PRICE_HISTORY_BY_ID_SUCCESS,
    data
  };
};

export const getPricePointsSuccess = (data) => {
  return {
    type: PRICE_POINTS_SUCCESS,
    data,
  };
};

export const getPricePointById = (id) => {
  return (dispatch) => {
    dispatch(fetchStart());

    return getPricePointByIdAPI(id)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getPricePointByIdSuccess(response.data.response));
        return response.data.response;
      })
      .catch((error) => {
        dispatch(fetchEnd());
        console.error('Error fetching price point by ID:', error);
        throw error;
      });
  };
};

const getPricePointByIdAPI = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };

  return axios.get(`price-points/${id}`, { headers: headers });
};

export const getPricePointByIdSuccess = (data) => {
  return {
    type: PRICE_POINTS_BY_ID,
    data,
  };
};

export const getPricePointByName = (name, applicationType) => {
  return (dispatch) => {
    dispatch(fetchStart());

    return getPricePointByNameAPI(name, applicationType)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getPricePointByNameSuccess(response.data.response));
        return response.data.response;
      })
      .catch((error) => {
        dispatch(fetchEnd());
        console.error('Redux Action: Error fetching price point by name:', error);
        console.error('Redux Action: Error response:', error.response);
        throw error;
      });
  };
};

const getPricePointByNameAPI = (name, applicationType) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };

  const params = { name };
  if (applicationType) {
    params.application_type = applicationType;
  }


  return axios.get('price-points', { headers: headers, params })
    .catch((error) => {
      console.log('First attempt failed, trying alternative URL pattern');
      // Try alternative URL pattern
      return axios.get('price-points/search', { headers: headers, params });
    });
};

export const getPricePointByNameSuccess = (data) => {
  return {
    type: PRICE_POINTS_BY_NAME,
    data,
  };
};

// Create/Update Price Point Actions
export const createOrUpdatePricePoint = (pricePointData) => {
  return (dispatch) => {
    dispatch(fetchStart());
    return createOrUpdatePricePointAPI(pricePointData)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(createOrUpdatePricePointSuccess(response.data));
        console.log('Price point created/updated successfully:', response.data);
        // Extract toast messages from API response
        const toastMessages = [];
        if (response.data?.message) {
          const messages = Array.isArray(response.data.message)
            ? response.data.message
            : [{ message_type: 'success', message: response.data.message }];

          messages.forEach((msg) => {
            if (msg && msg.message_type && msg.message) {
              toastMessages.push({
                type: msg.message_type.toLowerCase(),
                message: msg.message
              });
            }
          });
        }
        // Fallback: If no messages, add default success
        if (toastMessages.length === 0) {
          toastMessages.push({
            type: 'success',
            message: response.status === 201
              ? 'Price point created successfully!'
              : 'Price point updated successfully!'
          });
        }
        response.toastMessages = toastMessages;
        return response; // Return response so component can access it
      })
      .catch((error) => {
        dispatch(fetchEnd());
        console.error('Error creating/updating price point:', error);
        // Extract error messages from API response
        const toastMessages = [];
        if (error.response?.data?.message) {
          const messages = Array.isArray(error.response.data.message)
            ? error.response.data.message
            : [{ message_type: 'error', message: error.response.data.message }];

          messages.forEach((msg) => {
            if (msg && msg.message_type && msg.message) {
              toastMessages.push({
                type: msg.message_type.toLowerCase(),
                message: msg.message
              });
            }
          });
        }
        // Fallback: If no messages, add default error
        if (toastMessages.length === 0) {
          toastMessages.push({
            type: 'error',
            message: error.response?.data?.error ||
              error.response?.data?.detail ||
              error.message ||
              'Failed to save price point'
          });
        }
        error.toastMessages = toastMessages;
        dispatch(createOrUpdatePricePointError(error.response?.data || error.message));
        throw error; // Re-throw error so component can catch it
      });
  };
};

const createOrUpdatePricePointAPI = (pricePointData) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
    'Content-Type': 'application/json',
  };

  console.log('Creating/Updating price point with data:', pricePointData);
  return axios.post('price-points', pricePointData, { headers: headers });
};

export const createOrUpdatePricePointSuccess = (data) => {
  return {
    type: 'CREATE_UPDATE_PRICE_POINT_SUCCESS',
    data,
  };
};

export const createOrUpdatePricePointError = (error) => {
  return {
    type: 'CREATE_UPDATE_PRICE_POINT_ERROR',
    error,
  };
};

// Delete Price Point Actions
export const deletePricePoint = (id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    const headers = {
      Authorization: secureLocalStorage.getItem('aTk'),
    };
    return axios
      .delete(`/price-points/${id}`, { headers: headers })
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(deletePricePointSuccess(response.data));
        // Show toast immediately (delete stays on same page)
        if (response.data?.message) {
          const messages = Array.isArray(response.data.message)
            ? response.data.message
            : [{ message_type: 'success', message: response.data.message }];

          messages.forEach((msg) => {
            if (msg && msg.message_type && msg.message) {
              const msgType = msg.message_type.toLowerCase();
              if (msgType === 'success') newToast.showSuccess(msg.message);
              else if (msgType === 'error') newToast.showError(msg.message);
              else if (msgType === 'warning') newToast.showWarning(msg.message);
              else newToast.showInfo(msg.message);
            }
          });
        } else {
          newToast.showSuccess('Price point deleted successfully!');
        }
        return response; // Return response so component can access it
      })
      .catch((error) => {
        dispatch(fetchEnd());
        console.error('Error deleting price point:', error);
        // Show error toast immediately (delete stays on same page)
        if (error.response?.data?.message) {
          const messages = Array.isArray(error.response.data.message)
            ? error.response.data.message
            : [{ message_type: 'error', message: error.response.data.message }];

          messages.forEach((msg) => {
            if (msg && msg.message_type && msg.message) {
              const msgType = msg.message_type.toLowerCase();
              if (msgType === 'success') newToast.showSuccess(msg.message);
              else if (msgType === 'error') newToast.showError(msg.message);
              else if (msgType === 'warning') newToast.showWarning(msg.message);
              else newToast.showInfo(msg.message);
            }
          });
        } else {
          newToast.showError(
            error.response?.data?.error ||
            error.response?.data?.detail ||
            error.message ||
            'Failed to delete price point'
          );
        }
        dispatch(deletePricePointError(error.response?.data || error.message));
        throw error; // Re-throw error so component can catch it
      });
  };
};

export const deletePricePointSuccess = (data) => {
  return {
    type: DELETE_PRICE_POINT_SUCCESS,
    data,
  };
};

export const deletePricePointError = (error) => {
  return {
    type: DELETE_PRICE_POINT_ERROR,
    error,
  };
};

export const executePricePoint = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    executePricePointAPI(data)
      .then((response) => {
        dispatch(fetchEnd());
        toast.success(response.data.message);
        dispatch(executePricePointSuccess(response.data.response));
      })
      .catch((error) => {
        dispatch(fetchEnd());
        dispatch(executePricePointError(error.response?.data || error.message));
      });
  };
};

const executePricePointAPI = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };

  return axios.post('price-points/execute', data, { headers: headers });
};

export const executePricePointSuccess = (data) => {
  return {
    type: PRICE_POINT_EXECUTE_SUCCESS,
    data,
  };
};

export const executePricePointError = (error) => {
  return {
    type: PRICE_POINT_EXECUTE_ERROR,
    error,
  };
};

export const clearPricePointExecuteResult = () => {
  return {
    type: CLEAR_PRICE_POINT_EXECUTE_RESULT,
  };
};
export const priceListConfig = (priceListId) => {
  return (dispatch) => {
    dispatch(fetchStart());
    priceListConfigAPI(priceListId)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(priceListConfigSuccess(response.data.response));
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const priceListConfigAPI = (priceListId) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };

  return axios.get('pricing/price-list-data/' + priceListId, { headers: headers });
};

export const priceListConfigSuccess = (data) => {
  return {
    type: PRICE_LIST_CONFIG,
    data,
  };
};

export const setSelectedPriceListByRule = (ruleName, priceListId) => ({
  type: SET_SELECTED_PRICE_LIST_BY_RULE,
  ruleName,
  priceListId,
});

export const setUnsavedPriceChanges = (changes) => ({
  type: SET_UNSAVED_PRICE_CHANGES,
  changes,
});

export const clearUnsavedPriceChanges = () => ({
  type: CLEAR_UNSAVED_PRICE_CHANGES,
});
